export default __webpack_public_path__ + "static/nalbert-6de87004ee3371ae18940547f8808dc6.jpg";